<template>
  <div class="page">
    <b-container
        v-if="pageContent"    
        class=""
    >
      <b-row>
        <b-col
          sm="12"
          md="8"
        >
            <h1>{{ pageContent.title}}</h1>
            <div
                v-html="pageContent.content"
            />
        </b-col>
        <b-col
          sm="12"
          md="4"
        >
          <!-- <h3
            class=""
          >
            Sidebar
          </h3>        
          <p>Inhalt Sidebar</p> -->
        </b-col>
      </b-row>
    </b-container>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'page',
  components: {
     
  },
  data () {
      return {
        
      }
  },
  methods: {
    ...mapActions({
        setCurrentPage: 'setCurrentPage'
    }),
    setPage () {
        this.setCurrentPage(this.$route.params.slug)
        console.log('Page set, state.currentPage: ', this.$route.params.slug)
    }
  },
  watch: {
      '$route': 'setPage'
  },
  computed: {
    ...mapGetters({
      pageContent: 'getPageContent'
    })
  },
  created () {
    this.setPage()
  }
}
</script>
<style scoped>

</style>
